<template>
  <ClientOnly>
    <Teleport to="body">
      <div
        v-if="isVisible"
        class="dialog-layer"
        role="presentation"
        @click.self="handleOverlayClick"
      >
        <article
          class="dialog dialog--compact"
          :class="{ 'dialog--choice': isConfirm }"
          role="dialog"
          aria-modal="true"
          :aria-labelledby="modalOptions.title ? 'app-dialog-title' : undefined"
          :aria-describedby="modalOptions.message ? 'app-dialog-description' : undefined"
        >
          <div class="dialog__copy">
            <h1 v-if="modalOptions.title" id="app-dialog-title" class="dialog__title">
              {{ modalOptions.title }}
            </h1>
            <div
              v-if="modalOptions.message"
              id="app-dialog-description"
              class="dialog__description"
              v-html="modalOptions.message"
            />
          </div>
          <div class="dialog__actions" :class="{ 'dialog__actions--double': isConfirm }">
            <button
              v-if="isConfirm"
              type="button"
              class="button button--secondary"
              @click="handleCancel"
            >
              {{ modalOptions.cancelText || "취소" }}
            </button>
            <button
              type="button"
              class="button"
              :class="modalOptions.confirmVariant === 'danger-solid' ? 'button--danger-solid' : 'button--primary'"
              @click="handleConfirm"
            >
              {{ modalOptions.confirmText || "확인" }}
            </button>
          </div>
        </article>
      </div>
    </Teleport>
  </ClientOnly>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from "vue";
import { useModalStore } from "../stores/modal";

const modalStore = useModalStore();

const modalOptions = computed(() => modalStore.modalAlertOptions || {});
const isConfirm = computed(() => modalOptions.value.type === "confirm" || modalStore.modalType === "confirm");
const isVisible = computed(() => {
  if (!modalStore.isModalVisible) return false;
  return modalStore.modalType === "alert" || modalStore.modalType === "confirm";
});

const handleConfirm = () => {
  modalStore.confirmModal();
};

const handleCancel = () => {
  modalStore.cancelModal();
};

const handleOverlayClick = () => {
  if (isConfirm.value) return;
  modalStore.closeModalAlert();
};

const handleKeydown = (event) => {
  if (event.key !== "Escape" || !isVisible.value) return;
  if (isConfirm.value) {
    handleCancel();
    return;
  }
  modalStore.closeModalAlert();
};

onMounted(() => {
  document.addEventListener("keydown", handleKeydown);
});

onUnmounted(() => {
  document.removeEventListener("keydown", handleKeydown);
});
</script>
